import { render, staticRenderFns } from "./ModalView.vue?vue&type=template&id=2f6279ad&scoped=true&"
import script from "./ModalView.vue?vue&type=script&lang=ts&"
export * from "./ModalView.vue?vue&type=script&lang=ts&"
import style0 from "./ModalView.vue?vue&type=style&index=0&id=2f6279ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6279ad",
  null
  
)

export default component.exports